import { Button, Container } from "components";
import "./styles.scss";
import { HeaderInfoProps } from "./types";

export default function HeaderInfo({
	icon,
	title,
	subtitle,
	href,
	buttonText
}: HeaderInfoProps) {
	return (
		<div className="container-header-info">
			<Container className="stack--3 items-center text-center mx-auto">
				<div className="icon">{icon && icon}</div>
				<p>{title}</p>
				{subtitle && <p className="text-neutral-low-400">{subtitle}</p>}
				{href && buttonText && (
					<a className="mt-8" href={href}>
						<Button styled="primary">{buttonText}</Button>
					</a>
				)}
			</Container>
		</div>
	);
}
